import { type ComponentPropsWithoutRef, forwardRef } from "react";

import { type LinkComponent, createLink } from "@tanstack/react-router";

import { NavBarLink as UiNavLink } from "@shared/ui/atoms";

type UiLinkProps = ComponentPropsWithoutRef<typeof UiNavLink>;

interface RouterLinkProps extends Omit<UiLinkProps, "href"> {}

const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(
  (props, ref) => {
    return <UiNavLink ref={ref} {...props} />;
  },
);

export const NavBarLink = createLink(RouterLink);

export type NavLinkComponent = LinkComponent<typeof NavBarLink>;
